module.exports = __webpack_public_path__ + "img/火龙果9.fdda155d.png";